<template>
  <div>
          <div class="seccion-02">
        <img src="../../assets/style/images/demo.jpg" class="d-block" alt="...">
    </div>

    <section class="seccion-01">
        <div class="container justify-content-center">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="card-organigrama">
                        <h4 class=" text-center mt-3">
                            Escuela Nacional de Estudios Superiores, Unidad Mérida
                        </h4>
                        <h1 class="titulo_C01 mt-3">
                            H. Consejo Técnico <br> Calendario Anual de Sesiones 2020
                        </h1>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 ">
                    <table class="table table-borderless table_C01">
                        <thead>
                            <tr class="lineaAzul">
                                <th class="titulo_C02">Sesión</th>
                                <th class="titulo_C03">Fecha</th>
                                <th class="titulo_C04">Cierre de Recepción <br> de Documentos</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="subtitulo_C01">1ª Ordinaria</td>
                                <td class="subtitulo_C02">13 de enero 2020 </td>
                                <td class="subtitulo_C01">10 de enero 2020 </td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">2ª Ordinaria</td>
                                <td class="subtitulo_C02">07 de febrero 2020 </td>
                                <td class="subtitulo_C01">31 de enero 2020 </td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">3ª Ordinaria</td>
                                <td class="subtitulo_C02">06 de marzo 2020</td>
                                <td class="subtitulo_C01">28 de febrero 2020 </td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">4ª Ordinaria</td>
                                <td class="subtitulo_C02">03 de abril 2020 </td>
                                <td class="subtitulo_C01">27 de marzo 2020</td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">5ª Ordinaria</td>
                                <td class="subtitulo_C02">08 de mayo 2020 </td>
                                <td class="subtitulo_C01">30 de abril 2020 </td>
                            </tr>


                            <tr>
                                <td class="subtitulo_C01">6ª Ordinaria</td>
                                <td class="subtitulo_C02">05 de junio 2020 </td>
                                <td class="subtitulo_C01">29 de mayo 2020</td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">7ª Ordinaria</td>
                                <td class="subtitulo_C02">07 de agosto 2020 </td>
                                <td class="subtitulo_C01">31 de julio 2020 </td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">8ª Ordinaria</td>
                                <td class="subtitulo_C02">04 de septiembre 2020 </td>
                                <td class="subtitulo_C01">28 de agosto 2020</td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">9ª Ordinaria</td>
                                <td class="subtitulo_C02">02 de octubre 2020 </td>
                                <td class="subtitulo_C01">25 de septiembre 2020 </td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">10ª Ordinaria</td>
                                <td class="subtitulo_C02">06 de noviembre 2020</td>
                                <td class="subtitulo_C01">30 de octubre 2020</td>
                            </tr>

                            <tr>
                                <td class="subtitulo_C01">11ª Ordinaria</td>
                                <td class="subtitulo_C02">04 de diciembre 2020</td>
                                <td class="subtitulo_C01">27 de noviembre 2020</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mb-5">
                    <img src="#" class="img-fluid logoD" alt="...">
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <h6 class="subtitulo_C03 mt-3">
                        * El H. Consejo Técnico podrá sesionar de manera extraordinaria para conocer asuntos específicos o para tratar asuntos relevantes o urgentes.
                    </h6>
                </div>
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <img src="#" class="img-fluid logoI" alt="...">
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>